import { ISaveService } from "../../../../../abstractions/services/actions/ISaveService";
import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import { CompraAnimalesRequest } from "../../../../../modulos/pesaje/ganaderia/request/CompraAnimalesRequest";
import { CompraAnimalesResponse } from "../../../../../modulos/pesaje/ganaderia/response/CompraAnimalesResponse";
import { CompraAnimalesSaveGrpcService } from "../../../../../modulos/pesaje/ganaderia/services/CompraAnimalesSaveGrpcService";
import { BaseFullScreenFormModalRender } from "../../../../base/modal/BaseFullScreenFormModalRender";
import { IFormBodyRender } from "../../../../definitions/form/IFormBodyRender";
import { CompraFormRender } from "../form/CompraFormRender";

/** Modal a pantalla completa de creación/edición de una compra de animales.
 *  Hospeda el `CompraFormRender` y guarda con `CompraAnimalesSaveGrpcService`. */
export class CompraModalRender extends BaseFullScreenFormModalRender<
  CompraAnimalesRequest,
  CompraAnimalesResponse
> {
  protected readonly elementId = "compraModal";

  protected get title(): string {
    return "Compra de animales";
  }

  protected get subtitle(): string | undefined {
    return serviceProvider.getFincaSelectedService().get()?.nombreFinca;
  }

  protected get saveLabel(): string {
    return "Registrar Compra";
  }

  protected getFormBody(): IFormBodyRender {
    return new CompraFormRender(this._request);
  }

  protected get saveService(): ISaveService<
    CompraAnimalesRequest,
    CompraAnimalesResponse
  > {
    return new CompraAnimalesSaveGrpcService();
  }
}
